export const DASHBOARD_SOURCE = 'whitelist-dashboard';

export const PAGE_SIZE = 10;

export const DESCRIPTION_MAX_LENGTH = 150;
